import React from 'react';

import Editor, {IEditorProps} from '../editor';
import {pick} from 'lodash';
import AbstractPreviewDetailsForm from '../editor/components/abstractPreviewDetailsForm/AbstractPreviewDetailsForm';

interface IPreparedEditorProps extends Omit<IEditorProps, "getProductInfo" | "getStepContent"> {
  detailsEditorComponent: any;
  saleEditorComponent: any;
  previewComponent?: any;
  topDetailsComponent: any
}

const PreparedEditor = ({
                          detailsEditorComponent: DetailsEditorComponent,
                          saleEditorComponent: SaleEditorComponent,
                          previewComponent: PreviewComponent,
                          topDetailsComponent: TopDetailsComponent,
                          ...props
                        }: IPreparedEditorProps) => {
  return (
    <Editor {...props}
            getProductInfo={(activeStep: number, {
              product,
              setSubmitRef,
              ...rest
            }: any, nextStep: (data: any) => Promise<any> = (data) => Promise.resolve()) => {
              switch (activeStep) {
                case 1:
                case 2:
                  return (
                    <TopDetailsComponent
                      product={product}
                    />);
                default:
                  return '';
              }
            }}
            getStepContent={(activeStep: number, {
              product,
              setSubmitRef,
              ...rest
            }: any, nextStep: (data: any) => Promise<any> = (data) => Promise.resolve()) => {
              switch (activeStep) {
                case 0:
                  return (<DetailsEditorComponent
                    {...rest}
                    {...pick(product, Object.keys(props.product))}
                    setSubmitRef={setSubmitRef}
                    onSubmit={(formValues) => nextStep({
                      ...pick(formValues, Object.keys(props.product)),
                      activeStep: 1
                    })}/>);
                case 1:
                  return (
                    <SaleEditorComponent
                      {...rest}
                      {...pick(product, [...Object.keys(props.product), 'saleDetails'])}
                      setSubmitRef={setSubmitRef}
                      onSubmit={({activeStep, ...formValues}) => nextStep({
                        saleDetails: formValues,
                        activeStep
                      })}/>
                  )
                    ;
                case 2:
                  return (<PreviewComponent
                    {...rest}
                    product={product}
                    setSubmitRef={setSubmitRef}
                    onSubmit={({activeStep, ...formValues}) => nextStep({
                      activeStep,
                      ...formValues
                    })}
                  />);
                default:
                  return '';
              }
            }}

    />
  );
};

PreparedEditor.defaultProps = {
  previewComponent: AbstractPreviewDetailsForm,
}


export default PreparedEditor;
